import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { UsersComponent } from './users.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { DenyNonStaffService } from '../shared/services/deny-non-staff.service';
import { DenyStaffService } from '../shared/services/deny-staff.service';
import { UsersService } from './users.service';
import { FormsModule } from '@angular/forms';
import { SortUsersPipe} from "./pipes/sort-users-pipe";

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    RouterModule.forChild([
      { path: 'users', component: UsersComponent, canActivate:[AuthGuardService, DenyNonStaffService, DenyStaffService] }
    ])
  ],
  providers: [
    UsersService
  ],
  declarations: [UsersComponent, SortUsersPipe]
})
export class UsersModule { }



// WEBPACK FOOTER //
// ./src/app/users/users.module.ts